import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useLocale } from 'next-intl';
import bywayXCoOpHolidaysLogo from '~/assets/logos/byway-coop-lined.svg';
import bywayLogo from '~/assets/logos/byway-logotype.svg';
import bywayLogoBlack from '~/assets/logos/byway-logotype-black.svg';
import bywayXTheGuardianHolidaysLogo from '~/assets/logos/byway-the-guardian-holiday.svg';
import type { Locale } from '~/i18n/i18n-config';
import { getPathname } from '~/i18n/navigation';
import { usePartner } from '~/libs/partners';
interface NavigationLogoProps {
  theme?: 'light' | 'dark';
}
export default function NavigationLogo(t0) {
  const $ = _c(14);
  const {
    theme: t1
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const partner = usePartner();
  const locale = useLocale() as Locale;
  let t2;
  if ($[0] !== locale) {
    t2 = process.env.NEXT_PUBLIC_FF_ENABLE_DATO_DRIVEN_HEADER_NAVIGATION === "true" ? getPathname({
      href: "/",
      locale
    }) : "https://www.byway.travel/";
    $[0] = locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const homeUrl = t2;
  let t3;
  if ($[2] !== partner) {
    t3 = partner === "co-op holidays" && <Image src={bywayXCoOpHolidaysLogo} width={333} height={40} alt="Byway and Co-op Holidays logo - Homepage" priority={true} />;
    $[2] = partner;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== partner) {
    t4 = partner === "guardian-holidays" && <Image src={bywayXTheGuardianHolidaysLogo} width={157} height={40} alt="Byway and The Guardian Holidays logo - Homepage" priority={true} />;
    $[4] = partner;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== partner || $[7] !== theme) {
    t5 = partner !== "co-op holidays" && partner !== "guardian-holidays" && <Image src={theme === "light" ? bywayLogoBlack : bywayLogo} width={132} height={40} alt="Byway logo - Homepage" priority={true} />;
    $[6] = partner;
    $[7] = theme;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== homeUrl || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <a href={homeUrl} aria-label="Byway Homepage" data-class="logo" className="w-full">{t3}{t4}{t5}</a>;
    $[9] = homeUrl;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}